import React, { useEffect } from 'react';
// import English from '../../../../assets/images/english.svg';
// import Nepal from '../../../../assets/images/nepal.svg';
import {Container, Input, InputAdornment} from '@material-ui/core';
import { useHistory, useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import { lang as language} from '../../../../config/app.config';
import { setLocalstorage } from '../../../../utils/localstorage.utils';
import {Link} from 'react-router-dom';
import { FiSearch, FiMail } from 'react-icons/fi';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { debounce } from 'lodash';
import { ecnSearch } from '../../../../services/search.service';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import {TranslationState}  from '../../../../store/ActionReducers/translation.actionreducer';
import {fetchTranslation} from '../../../../services/translation.service';
import translates from '../../../../translation.json';

interface param{
  lang:string,
  dist_slug:string
}

export const OLD_WEBSITE = process.env.REACT_APP_OLD_URL;

const Topbar:React.FC = ()=>{

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector((state:{translation:TranslationState})=>state.translation);
  const {translation} = state;
  const {lang,dist_slug} = useParams<param>();

  // fetch translationarray
  useEffect(() => {
    if(!translation) dispatch(fetchTranslation());
  }, []);//eslint-disable-line
  // end fetch translation array

  useEffect(()=>{
    if(language !== lang){
      if(lang === 'en'){
        setLocalstorage('lang','en');
        window.location.reload();
      }else{
        setLocalstorage('lang','np');
        let locationArray = location.pathname.split('/');
        locationArray[1] = 'np';
        let path = locationArray.join('/');
        history.push(path)
        window.location.reload();
      }
    }
  },[lang])//eslint-disable-line

  useEffect(() => {
    if(language === 'np'){
      document.body.classList.add('nepali');
    }else{
      document.body.classList.remove('nepali');
    }
  }, [language]);//eslint-disable-line

  const setlang = (lang:'np'|'en') =>{
    let locationArray = location.pathname.split('/');
    let currentLang = locationArray[1];
    if(currentLang !== lang){
      locationArray[1] = lang;
      let path = locationArray.join('/');
      history.push(path)
    }
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = debounce((e:any)=>{
    dispatch(push(`/${lang}/search`));
    dispatch(ecnSearch(e.target.value));
  },1000);


return(
  <div className="ecn-topbar">
    <Container maxWidth="lg">
      <div className="display-flex-ac">
      {
        dist_slug? 
        <h1 className="text-14-primary" style={{flex:2,marginRight:"1em"}}>
          <Link to={`/${language}`} className="text-primary">{translation?translation.main_site[language==='np'?'value_np':'value_en']:''}</Link>
        </h1>
        :""
      }
      <div  style={{flex:8}}>
        <ul className="ecn-topbar--menu">
          <li>
            <Link to={`/${language}/faqs`}>
              <span style={{textAlign:'right'}}>{translation?translation.faq[language==='np'?'value_np':'value_en']:''}</span>
            </Link>
          </li>
          {
            language === 'np'?
            <li>
              <p onClick={()=>setlang('en')}>
                {/* <img src={English} alt="english"/> */}
                <span className="eng-number" style={{lineHeight:'19.5px'}}>English</span>
              </p>
            </li>:
            <li>
              <p onClick={()=>setlang('np')} style={{lineHeight:'19.5px'}}>
                {/* <img src={Nepal} alt="nepali"/> */}
                <span>नेपाली</span>
              </p>
            </li>
          }
          
          <li>
            <p onClick={handleClick} style={{padding:'3px'}}>
              <FiSearch/>
            </p>
           
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem className="search-bar">
                <Input
                  placeholder={lang === 'np'?"तपाईँ के खोज्दै हुनुहुन्छ ?":"What are you looking for?"}
                  className="search-input"
                  onChange={handleSearch}
                  
                  endAdornment={<InputAdornment position="end"><FiSearch className="icon"/></InputAdornment>}
                />
              </MenuItem>
            </Menu>
          </li>

          <li>
            <p>
            <a href="https://mail.election.gov.np/mail/" target="_blank" rel="noreferrer" className="text-primary">
              <FiMail/>
            </a>
            </p>
          </li>

          <li>
              <a href={OLD_WEBSITE} target="_blank">
                <span className="eng-number">{language === 'np'? 'पुरानो वेबसाइट' :'Old Website' }</span>
              </a>
          </li>

        </ul>
      </div>
      
      </div>
    </Container>
  </div>
);
}

export default Topbar;